import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import PropertyInformation from "../Shared/Information/PropertyInformation";
// import TenantInformation from "../Shared/Information/TenantInformation";
import Title from "../../Helpers/Title";
import { Icon, Button, Grid } from "@material-ui/core";
import LinkHelper from "../../Helpers/Link";
import { connect } from "react-redux";
import { getSingleMatch, setInterested } from "../../../actions/userActions";
import PropertyPics from "../Shared/PropertyPics";
import { capitalize } from "../../../actions/utils";

const empty = "-";
class PropertyMatchInfo extends Component {

    static propTypes = {
        match: PropTypes.object,
        announcement: PropTypes.object
    }

    constructor( props ) {
        super( props );
        this.setLocalInterested = this.setLocalInterested.bind( this );
        this.state = {
            interestedButtonState: undefined
        }
    }

    componentDidMount() {
        if ( this.props.announcement ) {
            this.props.getMatch( this.props.announcement.id );
        }
    }

    setLocalInterested( isInterested ) {
        this.setState({
            interestedButtonState: isInterested
        });
    }

    translatePropsToProfile( properties ) {

        const translateArray = ( array ) => {
            if ( !array )
                return empty;
            let matches;
            if ( Array.isArray( array ) ) {
                matches = array;
            }
            else if ( typeof array === "string" ) {
                if ( array === "{}" )
                    return empty;
                const arrayRegex = /"[^"]+"/g;
                const captures = array.match( arrayRegex );
                if ( !captures )
                    matches = [array];
                else
                    matches = captures.map( m => m.substring( 1, m.length - 1 ) );
            }
            let result = "";
            for ( let i = 0; i < matches.length; i++ ) {
                result = `${result}${result ? ", " : ""}${capitalize( matches[i] )}`;
            }
            return result;
        }

        const translateRange = ( array ) => {
            const maxValue = 6;
            if ( !array )
                return empty;
            if ( !Array.isArray( array ) )
                return array;
            if ( array.length === 0 )
                return empty;
            const sorted = array.map( v => Number( v ) );
            sorted.sort( ( a, b ) => a - b );
            const ranges = [];
            var start = sorted[0];
            var end = sorted[0];
            for ( let i = 1; i < sorted.length; i++ ) {
                if ( sorted[i] !== ( end + 1 ) ) { // Start a new range if the current is "broken". As an example, when value jumps from 2 to 4 instead of continuing with 3
                    ranges.push( [start, end] );
                    start = sorted[i];
                    end = sorted[i];
                }
                else {
                    end++;
                }
            }
            ranges.push( [start, end] );
            let result = "";
            for ( let i = 0; i < ranges.length; i++ ) {
                const from = ranges[i][0];
                const to = ranges[i][1];
                if ( i === ( ranges.length - 1 ) && to === maxValue )
                    result = `${result}${result ? ", " : ""}${from}+`
                else
                    result = `${result}${result ? ", " : ""}${from === to ? from : `${from} - ${to}`}`
            }
            return result;
        }

        const result = { ...properties };
        result.industry = properties.industries;
        result.creditRating = translateArray( properties.creditRating );
        result.employee = translateRange( properties.employee );

        return result;
    }

    render() {
        const { match, singleMatch, setInterested, user, announcement } = this.props;
        const comparison = match ? match : singleMatch;
        const isInterested = this.state.interestedButtonState === undefined
            ? ( comparison
                ? ( comparison.isInterested ? comparison.isInterested.some( u => u.id === user.id ) : false )
                : false )
            : this.state.interestedButtonState;
        console.log( "COMPARISON >>", comparison ); // DEBUG
        return (
            <div className="User-content">
                <LinkHelper to="/user/matches">
                    <Button
                        color="secondary"
                    >
                        <Icon>arrow_back</Icon>&nbsp;Go back to the previous page
                    </Button>
                </LinkHelper>
                { comparison &&
                    <Fragment>
                        <Grid container justify="space-between">
                            <Title title="Property & Landlord Profile"/>
                            <div>
                                <Button
                                    variant={isInterested ? "contained" : "outlined"}
                                    color={isInterested ? "primary" : "secondary"}
                                    size="large"
                                    onClick={() => {
                                        this.setLocalInterested( isInterested ? false : true );
                                        setInterested( comparison.announcement.id, isInterested ? false : true );
                                    }}
                                >
                                    I'm Interested
                                </Button>
                            </div>
                        </Grid>
                        {/* <TenantInformation
                            title="Ideal tenant description"
                            profile={this.translatePropsToProfile( comparison.properties )}
                            compare={{
                                ...comparison.matches,
                                ...comparison.personMatches
                            }}
                            preferred
                        /> */}
                        <PropertyPics
                            title={'Property Pictures'}
                            residence={announcement.residence}
                        />
                        <PropertyInformation
                            listing
                            compare={{
                                ...comparison.matches,
                                ...comparison.personMatches
                            }}
                            title="Property information"
                            properties={
                                comparison.announcement.properties
                                    ? {
                                        ...comparison.announcement.properties,
                                        residenceType: comparison.announcement.residence.houseType
                                    }
                                    : {}
                            }
                        />
                    </Fragment>
                }
            </div>
        );
    }

}

export default connect(
    state => ({
        singleMatch: state.user.singleMatch,
        singleMatchState: state.user.singleMatchState,
        user: state.user.data
    }),
    dispatch => ({
        getMatch: ( annoId ) => dispatch( getSingleMatch( annoId ) ),
        setInterested: ( id, interested ) => dispatch( setInterested( id, interested ) )
    })
)( PropertyMatchInfo );